import _jsx from '@babel/runtime/helpers/esm/jsx';
import { ThemeProvider } from 'styled-components';
import { useMakeSelect } from '@dbh/reselect-extra';
import { makeSelectCustomizedColors } from '@dbh/site-customizations-redux';
import _isEqual from 'lodash/isEqual';
import { useCallback } from 'react';

const useModifyTheme=(a,b)=>{const c=useCallback(c=>b?c&&_isEqual(b,c.colors)?c:a(c,b):a(c),[b,a]);return c};var useModifyTheme$1 = useModifyTheme;

const ThemeCustomizationsProvider=a=>{let{createStyledComponentsTheme:b,children:c}=a;const d=useMakeSelect(makeSelectCustomizedColors),e=useModifyTheme$1(b,d);return/*#__PURE__*/_jsx(ThemeProvider,{theme:e},void 0,c)};ThemeCustomizationsProvider.displayName="ThemeCustomizationsProvider";var ThemeCustomizationsProvider$1 = ThemeCustomizationsProvider;

export { ThemeCustomizationsProvider$1 as ThemeCustomizationsProvider };
